import { render } from "./ProjectManageView.vue?vue&type=template&id=696ece9a&scoped=true"
import script from "./ProjectManageView.vue?vue&type=script&lang=js"
export * from "./ProjectManageView.vue?vue&type=script&lang=js"

import "./ProjectManageView.vue?vue&type=style&index=0&id=696ece9a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696ece9a"]])

export default __exports__